import React, { useState } from 'react';
import { useThemeLanguage } from '../context/ThemeLanguageContext';
import { getTranslation } from '../translations';
import './LandingFaq.css';

const FAQ_ITEMS = [
  { q: 'faq1Q', a: 'faq1A' },
  { q: 'faq2Q', a: 'faq2A' },
  { q: 'faq3Q', a: 'faq3A' },
  { q: 'faq4Q', a: 'faq4A' },
];

export default function LandingFaq() {
  const { language } = useThemeLanguage();
  const t = (key) => getTranslation(language, 'landing', key);
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="landing-faq" id="faq">
      <div className="container">
        <h2 className="landing-faq-title">{t('faqTitle')}</h2>
        <div className="landing-faq-list">
          {FAQ_ITEMS.map((item, index) => (
            <div
              key={item.q}
              className={`landing-faq-item ${openIndex === index ? 'open' : ''}`}
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            >
              <div className="landing-faq-question">
                <h3>{t(item.q)}</h3>
                <span className="landing-faq-toggle">{openIndex === index ? '−' : '+'}</span>
              </div>
              {openIndex === index && (
                <div className="landing-faq-answer">
                  <p>{t(item.a)}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
